import { render, staticRenderFns } from "./PreloaderComponent.vue?vue&type=template&id=bdcba040&scoped=true&"
import script from "./PreloaderComponent.vue?vue&type=script&lang=js&"
export * from "./PreloaderComponent.vue?vue&type=script&lang=js&"
import style0 from "./PreloaderComponent.vue?vue&type=style&index=0&id=bdcba040&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcba040",
  null
  
)

export default component.exports